import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';

import { SupplyInputBase } from './SupplyInputBase';

import { Text } from '@/shared/ui';
import { useModal } from '@/features/Modals/hooks';
/*In case of custom logic made override for SupplyInput here*/
import { useMaxBalance } from '@/features/Modals/ui/Pools/Supply/hooks/v2/useMaxBalance';

type SupplyAmountFieldProps = {
    name: string;
};

export const SupplyAmountField = ({ name }: SupplyAmountFieldProps) => {
    const { control } = useFormContext();
    const { modalProps } = useModal();

    const { balance: userBalance, tokenSymbol, currentApy, decimals } = modalProps || {};

    const maxBalance = useMaxBalance();

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <SupplyInputBase
                    {...field}
                    setValue={(value) => field.onChange(value)}
                    userBalance={userBalance}
                    tokenSymbol={tokenSymbol}
                    decimals={decimals}
                    disabled={Number(userBalance) === 0}
                    maxBalance={maxBalance}
                    label={
                        <>
                            <Text
                                type={Text.types.Paragraph}
                                className='text-content-tertiary font-medium'
                                name='supply-apy-label'
                            >
                                Supply APY:
                            </Text>
                            <Text
                                type={Text.types.Paragraph}
                                fontWeight={Text.weights.SemiBold}
                                name='supply-apy-value'
                            >
                                {currentApy}%
                            </Text>
                        </>
                    }
                />
            )}
        />
    );
};
